// @flow

/**
 * Module dependencies.
 */

import { translate } from 'react-i18next';

/**
 * Export `translator`.
 */

export function translator(options: Object = {}): Function {
  return translate(['translation'], { translateFuncName: 'translate', ...options });
}



// WEBPACK FOOTER //
// ../src/core/utils/translator.js